import { Storage } from '@ionic/storage';
import { Injectable, Inject } from '@angular/core';
import { LoopBackAuth } from '../sdk/services/core/auth.service';
import { NestAuthProvider } from '../nestjs/nest-auth';
import { GDAuthInterface, SaasData } from '../../model/gd-auth';
import { GetCompanySettingData } from '../nestjs/gd-all-in-one/dto/setting.dto';
import { ContactTracerData } from './app-preferences.dto';
import { MultipleAccount } from '../nestjs/gd-only/dto/multiple-acocunt.dto';

interface PreferenceSpec {
  key: string;
}

export enum Preference {
  Auth,
  Saas,
  CompanySetting,
  TokenNotification,
  Language,
  GDCheckRoot,
  GDWhiteListPackage,
  GDAttWorkLocation,
  // Page Builder
  PBLanguage,
  PBPages,
  NavParams,
  PBPageLeft,
  PBPageRight,
  PBAppMode,
  PBEnv,
  PBIsPageAccessible,
  PBSubmenu,
  PBPageNotification,
  PBFavoriteMenu,
  PBFilteredMenu,
  PBIssMenu,
  PBPageFeature,
  PBVersion,
  GDAttendanceOffline,
  GDActivityRecordingOffline,
  GDError,
  GDDeviceInfo,
  Announcement,
  Rating,
  Company,
  Guide,
  PolicyBackgroundLocation,
  CameraSetting,
  GDServerAppVersion,
  GDCounterFaceSpoofing,
  MenuSF7,
  GDAttBasePhoto,
  PolicySubmit,
  GDSwitchAccountTemp,
  MultipleAccount,
  GDAttendanceTodayForm,
  GDAttendanceTodayFormIsLoading,
}
@Injectable()
export class AppPreferences {

  // Storage Ionic
  private gdAuth: string = "SFGoAuth";
  private gdSaas: string = "SFGoStorage";
  private gdFcm: string = "fcm";
  private gdVersion: string = "SFGoAppVersion";
  private gdSplashcreen: string = "splashscreen";
  private gdLanguage: string = "language";
  private gdTheme: string = "new-theme";
  private gdError: string = "GDError";
  private gdDefaultPhoto: string = "GDPhotoAttendance";
  private gdCompany: string = "company";
  private gdPolling: string = "polling";
  private gdSettings: string = "GDAttendanceSetting";
  private gdAttWorklocation: string = "attWorkLocation";
  private gdCategoryPanicButton: string = "categoryPanicButton";
  private gdInternalPanicButton: string = "internalPanicButton";
  private gdContactTracer: string = "GDContactTracer";
  private gdMultipleAccount: string = "multipleAccount";
  private gdBluetoothEnabled: string = "GDBluetoothEnabled";
  private gdCheckRoot: string = "GDCheckRoot";
  private menuSF7: string = "MenuSF7";

  // Local Storage
  private gdWelcomeThermal: string = 'welcomeThermal';
  private _dataAuth: GDAuthInterface;
  private _dataSaas: SaasData;

  public languageCode = {
    en: "en", // english
    id: "in", // indonesia
    jp: "ja", // jepang
    th: "th", // thailand
    cn: "zh", // china
    kr: "ko" // korea
  }

  constructor(
    private storage: Storage,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestAuth: NestAuthProvider,
  ) {

  }

  private getStorageSpec(spec: Preference): PreferenceSpec {
    switch (spec) {
      case Preference.Auth:
        return { key: 'SFGoAuth' };
      case Preference.Saas:
        return { key: 'SFGoStorage' };
      case Preference.CompanySetting:
        return { key: 'GDAttendanceSetting' };
      case Preference.TokenNotification:
        return { key: 'fcmToken' };
      case Preference.Language:
        return { key: 'language' };
      case Preference.GDError:
        return { key: 'GDError' };
      case Preference.Announcement:
        return { key: 'announcement' };
      case Preference.Rating:
        return { key: 'rating' };
      case Preference.Company:
        return { key: 'company' };
      case Preference.GDAttendanceOffline:
        return { key: 'SFGoAttendanceLog' };
      case Preference.GDActivityRecordingOffline:
        return { key: 'SFGoActivityRecordingLog' };
      case Preference.Guide:
        return { key: 'guide' };
      case Preference.PolicyBackgroundLocation:
        return { key: 'GDPolicyBackgroundLocation' };
      case Preference.CameraSetting:
        return { key: 'GDCameraSetting' };
      case Preference.GDServerAppVersion:
        return { key: 'GDServerAppVersion' };
      case Preference.GDCounterFaceSpoofing:
        return { key: 'GDCounterFaceSpoofing' };
      case Preference.MenuSF7:
        return { key: 'MenuSF7' };
      case Preference.GDAttBasePhoto:
        return { key: 'GDAttBasePhoto' };
      case Preference.PolicySubmit:
        return { key: 'PolicySubmit' };
      case Preference.GDSwitchAccountTemp:
        return { key: 'GDSwitchAccountTemp' };
      case Preference.MultipleAccount:
        return { key: 'multipleAccount' };
      case Preference.GDAttendanceTodayForm:
        return { key: 'GDAttendanceTodayForm' };
      case Preference.GDAttendanceTodayFormIsLoading:
        return { key: 'GDAttendanceTodayFormIsLoading' };

      // Case Page Builder
      case Preference.PBLanguage:
        return { key: 'PBLanguage' };
      case Preference.PBPages:
        return { key: 'PBPages' };
      case Preference.NavParams:
        return { key: 'NavParams' };
      case Preference.PBPageLeft:
        return { key: 'PBPageLeft' };
      case Preference.PBPageRight:
        return { key: 'PBPageRight' };
      case Preference.PBAppMode:
        return { key: 'PBAppMode' };
      case Preference.PBIsPageAccessible:
        return { key: 'PBIsPageAccessible' };
      case Preference.PBEnv:
        return { key: 'PBEnv' };
      case Preference.PBSubmenu:
        return { key: 'PBSubmenu' };
      case Preference.PBPageNotification:
        return { key: 'PBPageNotification' };
      case Preference.PBFavoriteMenu:
        return { key: 'PBFavoriteMenu' };
      case Preference.PBFilteredMenu:
        return { key: 'PBFilteredMenu' };
      case Preference.PBIssMenu:
        return { key: 'PBIssMenu' };
      case Preference.PBPageFeature:
        return { key: 'PBPageFeature' };
      case Preference.PBVersion:
        return { key: 'PBVersion' };
      case Preference.GDCheckRoot:
        return { key: 'GDCheckRoot' };
      case Preference.GDWhiteListPackage:
        return { key: 'whiteListPackage' };
      case Preference.GDAttWorkLocation:
        return { key: 'attWorkLocation' };
      case Preference.GDDeviceInfo:
        return { key: 'GDDeviceInfo' };
    }
  }

  async getGreatdayStorage<T>(spec: Preference): Promise<T> {
    await this.storage.ready();
    const storageSpect = this.getStorageSpec(spec);
    const value = await this.storage.get(storageSpect.key);

    try {
      return JSON.parse(value) as T;
    } catch (error) {
      return value;
    }
  }

  async setGreatdayStorage(spec: Preference, value: any) {
    await this.storage.ready();
    return await this.storage.set(this.getStorageSpec(spec).key, JSON.stringify(value));
  }

  async removeGreatdayStorage(spec: Preference) {
    await this.storage.ready();
    return await this.storage.remove(this.getStorageSpec(spec).key);
  }

  /**
   * Auth
   */
  getAuth(): Promise<GDAuthInterface> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdAuth));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setAuth(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdAuth, JSON.stringify(data));
        this._dataAuth = data;
        this.auth.setToken(data);
        this.auth.save();
        this.nestAuth.setAuth.next(data);
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  get dataAuth() {
    return this._dataAuth;
  }

  get dataSaas() {
    return this._dataSaas;
  }

  /**
   * Storage
   */
  getSaasData(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdSaas));
        this._dataSaas = auth.storedPrelogin;
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setSaasData(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdSaas, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * FCM
   */
  getFcmData(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdFcm));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setFcmData(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdFcm, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Company
   */
  getCompanyData(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdCompany));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setCompanyData(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdCompany, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Version
   */
  getVersionData(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdVersion));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setVersionData(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdVersion, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Splash Screen
   */
  getSplashScreenData(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdSplashcreen));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setSplashScreenData(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdSplashcreen, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Language
   */
  getLanguageData(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = await this.storage.get(this.gdLanguage);
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setLanguageData(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdLanguage, data);
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Theme
   */
  getTheme(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = await this.storage.get(this.gdTheme);
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setTheme(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdTheme, data);
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Error ALL
   */
  getErrorMessage(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const error = await this.storage.get(this.gdError);
        resolve(error);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setErrorMessage(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdError, data);
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Error ALL
   */
  getDefaultPhotoAttendance(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const error = await this.storage.get(this.gdDefaultPhoto);
        resolve(error);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setDefaultPhotoAttendance(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdDefaultPhoto, data);
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Polling
   */
  getPolling(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = await this.storage.get(this.gdPolling);
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setPolling(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdPolling, data);
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Worklocation
   */
  getAttWorklocation(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const storage = JSON.parse(await this.storage.get(this.gdAttWorklocation));
        resolve(storage);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setAttWorklocation(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdAttWorklocation, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * List category panic button
   */
  getCategoryPanicButton(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const storage = JSON.parse(await this.storage.get(this.gdCategoryPanicButton));
        resolve(storage);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setCategoryPanicButton(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdCategoryPanicButton, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
 * List category panic button
 */
  getInternalPanicButton(): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const storage = JSON.parse(await this.storage.get(this.gdInternalPanicButton));
        resolve(storage);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setInternalPanicButton(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdInternalPanicButton, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Settings
   */
  getSettings(): Promise<GetCompanySettingData> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdSettings));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setSettings(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdSettings, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  getContactTracer(): Promise<Array<ContactTracerData>> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const result = JSON.parse(await this.storage.get(this.gdContactTracer))
        resolve(result)
      } catch (_) {
        resolve(null);
      }
    })
  }

  setContactTracer(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdContactTracer, JSON.stringify(data));
        resolve(true)
      } catch (error) {
        resolve(null);
      }
    })
  }

  /**
   * Multiple Account
   */
  getMultipleAccount(): Promise<MultipleAccount[]> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const auth = JSON.parse(await this.storage.get(this.gdMultipleAccount));
        resolve(auth);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setMultipleAccount(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdMultipleAccount, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  getBluetoothEnabled(): Promise<boolean> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const result = JSON.parse(await this.storage.get(this.gdBluetoothEnabled));
        resolve(result);
      } catch (error) {
        resolve(false);
      }
    })
  }

  setBluetoothEnabled(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdBluetoothEnabled, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  setGDCheckRoot(data: any): Promise<any> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        await this.storage.set(this.gdCheckRoot, JSON.stringify(data));
        resolve(true);
      } catch (error) {
        resolve(null);
      }
    })
  }

  getGDCheckRoot(): Promise<boolean> {
    return new Promise(async resolve => {
      try {
        await this.storage.ready();
        const result = JSON.parse(await this.storage.get(this.gdCheckRoot));
        resolve(result);
      } catch (error) {
        resolve(false);
      }
    })
  }

  /**
   * ***********************************************************************
   * Local storage
   * ***********************************************************************
   */

  /**
   * Thermal Face
   */
  getWelcomeThermal(): boolean {
    const data = localStorage.getItem(this.gdWelcomeThermal);
    return (data == 'true') ? true : false;
  }

  setWelcomeThermal(data: any): boolean {
    localStorage.setItem(this.gdWelcomeThermal, data);
    return true;
  }

  /**
   * Clear Storage
   */
  async clearStorage(): Promise<Boolean> {
    await this.storage.ready();
    let myMenu = null;
    let SFGoStorageDemo = localStorage.getItem('SFGoStorageDemo');
    let appVersion = await this.storage.get("SFGoAppVersion");
    let newTheme = await this.storage.get("new-theme");
    let guide = localStorage.getItem("guide");
    let ismore = localStorage.getItem("isMoore");
    let token = await this.storage.get('fcm');

    const language = await this.storage.get('language');
    const SFGoStorage = await this.getSaasData()
    const intro = await this.storage.get('intro') ? JSON.parse(await this.storage.get('intro')) : null;
    const introPayrollFrame = await this.storage.get('introPayrollFrame');
    const SFGoAttendanceLogVal = await this.storage.get('SFGoAttendanceLog')
    const SFGoActivityRecordingLog = await this.storage.get('SFGoActivityRecordingLog');
    const SFGoAuth = await this.getAuth()
    const multipleAccount = await this.storage.get("multipleAccount");

    try {
      myMenu = JSON.stringify({ menu: SFGoAuth.menu });
    } catch (e) {
    }

    /** Clear storage */
    await this.storage.clear();

    if (language != null && language != undefined && language != '') {
      this.storage.set('language', language);
    }

    if (SFGoStorage != null && SFGoStorage != undefined) {
      delete SFGoStorage["storedPrelogin"]["CUSTOM"]

      if (SFGoStorageDemo != 'isDemo') {
        this.storage.set('SFGoStorage', JSON.stringify(SFGoStorage));
      }

      localStorage.removeItem('SFGoStorageDemo');

      if (guide != null && guide != undefined) {
        localStorage.setItem("guide", guide);
      }
    }

    if (SFGoAttendanceLogVal != null && SFGoAttendanceLogVal != undefined && SFGoAttendanceLogVal != '') {
      this.storage.set('SFGoAttendanceLog', SFGoAttendanceLogVal);
    }

    if (SFGoActivityRecordingLog != null && SFGoActivityRecordingLog != undefined && SFGoActivityRecordingLog != '') {
      this.storage.set('SFGoActivityRecordingLog', SFGoActivityRecordingLog);
    }

    if (myMenu != null && myMenu != undefined && myMenu != "") {
      this.storage.set('SFGoAuth', myMenu);
    }

    if (intro != null && intro != undefined && intro != '') {
      this.storage.set('intro', JSON.stringify(intro));
    }

    if (introPayrollFrame != null && introPayrollFrame != undefined && introPayrollFrame != '') {
      this.storage.set('introPayrollFrame', introPayrollFrame);
    }

    if (appVersion) {
      this.storage.set('SFGoAppVersion', appVersion);
    }

    if (newTheme) {
      this.storage.set('new-theme', newTheme);
    }

    if (ismore != null && ismore != undefined) {
      localStorage.setItem("isMoore", ismore);
    }

    if (token) {
      this.storage.set('fcm', token);
    }

    if (multipleAccount) {
      this.storage.set('multipleAccount', multipleAccount);
    }

    return true;
  }

}


// WEBPACK FOOTER //
// ./src/shared/local/app-preferences.local.ts